import React, {useRef} from "react";

function MobileFilterModal({ children, handleClearAll }) {
  const modalRef = useRef(null);

  const openModal = () => {
    if (modalRef.current) {
      modalRef.current.showModal();
      document.body.classList.add('overflow-hidden');
    }
  };

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.close();
      document.body.classList.remove('overflow-hidden');
    }
  };
  return (
    <div className="mobile-filter-modal">
      <button aria-label="Open Filters" className='trigger' onClick={openModal}>
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="#BCAEA1"/>
          <path d="M21 25H40" stroke="#342649" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="26" cy="25" r="2" fill="#F7EDE4" stroke="#342649" strokeWidth="2"/>
          <path d="M21 31H40" stroke="#342649" strokeWidth="2" strokeLinecap="round"/>
          <path d="M21 37H40" stroke="#342649" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="35" cy="31" r="2" fill="#F7EDE4" stroke="#342649" strokeWidth="2"/>
          <circle cx="26" cy="37" r="2" fill="#F7EDE4" stroke="#342649" strokeWidth="2"/>
        </svg>
      </button>
      <dialog ref={modalRef} className="mobile-filters surface--light-cream">
        <div className="mobile-filters__header">
          <h5> Filters </h5>
          <button value='close' onClick={closeModal}> Close </button>
        </div>
        { children }
        <div className="mobile-filters__footer">
          <button value='op' onClick={handleClearAll}> Clear All </button>
          {/* Filters dynamically update so this should just close the modal */}
          <button className='btn btn-outline btn-small' value='apply' onClick={closeModal}> Apply Filters </button>
        </div>
      </dialog>
    </div>
  );
}

export default MobileFilterModal;
